// tslint:disable:max-line-length
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { WorkFieldInputChangeEvent } from '../../events/work-field-input-change-event';
import { E5coreUiWorkFieldTypeBase } from '../../components/e5core-ui-work-field/e5core-ui-work-field-type-base';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-field-type-integer',
  template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-work-field-type-integer-box *ngSwitchCase='0' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-integer-box>
    <e5core-ui-work-field-type-integer-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-integer-bootstrap>
    <e5core-ui-work-field-type-integer-material *ngSwitchCase='2' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-integer-material>
  </span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkFieldTypeIntegerComponent extends E5coreUiWorkFieldTypeBase {

  constructor(public style:UiStyleService) {
    super() ;
  }

  valueChange($event: WorkFieldInputChangeEvent) {
    this.dispatchPropertyChange(this.property.propertyId, $event.value, $event.error);
  }

}
